import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IVoucherFeature } from './voucher.feature.state';
import { getFailures, getIsLoading, getVoucher, getVoucherAutoApplyResponse, loyaltyVouchersToApply } from './voucher.selectors';
import { getVoucherAction, setLoyaltyVouchersToApplyAction, setVoucherAutoApplyAction } from './voucher.actions';
import { VoucherAutoApply, VouchersToApply } from '../models';

@Injectable()
export class VoucherFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public voucher$ = this.store.select(getVoucher);
  public getVoucherAutoApplyResponse$ = this.store.select(getVoucherAutoApplyResponse);
  public loyaltyVouchersToApply$ = this.store.select(loyaltyVouchersToApply);

  constructor(private store: Store<IVoucherFeature>) {}

  public getVoucher() {
    this.store.dispatch(getVoucherAction());
  }

  public setVoucherAutoApply(voucherAutoApply: VoucherAutoApply) {
    this.store.dispatch(setVoucherAutoApplyAction({ voucherAutoApply }));
  }

  public setLoyaltyVouchersToApply(loyaltyVouchers: VouchersToApply[]) {
    this.store.dispatch(setLoyaltyVouchersToApplyAction({ loyaltyVouchersToApply: loyaltyVouchers }));
  }
}
